import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import Table from 'react-bootstrap/Table';
import { GiTrafficLightsRed, GiTrafficLightsGreen } from 'react-icons/gi'; 
import Menu_generale_alunni from "./Pr_x8_1_menu_alunni.jsx";


const Tabella_Lista_alunni = (props) => {
//    const [somma, calcola_somma] = useState('');
    return (
        <div>
        <Menu_generale_alunni tutor = {props.tutor} classe_selezionata= {props.classe_selezionata} lista_alunni = {props.lista_alunni} />     
        <Table striped bordered hover>
            <thead>
                <tr>
                <th>#</th>
                <th>Cognome</th>
                <th>Nome</th>
                <th>Stato</th>
                </tr>
            </thead>
            <tbody>
     	    {Array.isArray(props.lista_alunni) && props.lista_alunni.map(function (item, index2) {
                        {
                        return <>
                        <tr>
                                <td>{index2+1}</td>
                                <td>{item.cognome}</td>
                                <td>{item.nome}</td>
                                <td>{item.progetto_in_futuro ? <GiTrafficLightsGreen color='green'/> : 
                                      <GiTrafficLightsRed color='red' />}</td>
                              
                                </tr>
                            </>
                        }
                    }
                )}
            </tbody>
            </Table>         
        </div>
    )
}
export default Tabella_Lista_alunni;